import { OFFICE_MACRO_RENDER_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { getExperienceTracker } from '@confluence/experience-tracker/entry-points/getExperienceTracker.ts';

const OFFICE_MACRO_NAMES = new Set([
	'word',
	'powerpoint',
	'excel',
	'viewdoc',
	'viewppt',
	'viewxls',
]);

export type OfficeMacroData = {
	macroName?: string;
};

const safelyTrackOfficeMacroExperience = (track: () => void): void => {
	try {
		track();
	} catch {
		// Telemetry must never block or alter macro rendering or insertion behaviour.
	}
};

export const OfficeMacroExperienceTrackerSupport: {
	isTrackable(data: OfficeMacroData | null | undefined): boolean;
	start(data: OfficeMacroData | null | undefined): void;
	succeed(): void;
	fail(error: Error): void;
	abort(reason: string): void;
} = new (class OfficeMacroExperienceTrackerSupport {
	isTrackable(data: OfficeMacroData | null | undefined): boolean {
		const normalizedMacroName = data?.macroName?.toLowerCase();
		return Boolean(normalizedMacroName && OFFICE_MACRO_NAMES.has(normalizedMacroName));
	}

	start(data: OfficeMacroData | null | undefined): void {
		safelyTrackOfficeMacroExperience(() => {
			getExperienceTracker().start({
				name: OFFICE_MACRO_RENDER_EXPERIENCE,
				attributes: {
					macroName: data?.macroName,
				},
			});
		});
	}

	succeed(): void {
		safelyTrackOfficeMacroExperience(() => {
			getExperienceTracker().succeed({
				name: OFFICE_MACRO_RENDER_EXPERIENCE,
			});
		});
	}

	fail(error: Error): void {
		safelyTrackOfficeMacroExperience(() => {
			getExperienceTracker().fail({
				name: OFFICE_MACRO_RENDER_EXPERIENCE,
				error,
			});
		});
	}

	abort(reason: string): void {
		safelyTrackOfficeMacroExperience(() => {
			getExperienceTracker().abort({
				name: OFFICE_MACRO_RENDER_EXPERIENCE,
				reason,
			});
		});
	}
})();
